import { render } from "./access.vue?vue&type=template&id=617eac67&scoped=true"
import script from "./access.vue?vue&type=script&lang=js"
export * from "./access.vue?vue&type=script&lang=js"

import "./access.vue?vue&type=style&index=0&id=617eac67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617eac67"]])

export default __exports__